import React from 'react';
import PropTypes from "prop-types";
import AbstractTab from "./AbstractTab";
import {connect} from "react-redux";
import {addDetailWindow, setDetailWindow} from "../../actions/details";
import * as OBC from "@thatopen/components";
import * as WEBIFC from "web-ifc";
import FeatureUtils from "../../utils/FeatureUtils";


class IfcTab extends AbstractTab {

    static propTypes = {
        addDetailWindow: PropTypes.func,
        feature: PropTypes.object,
        setDetailWindow: PropTypes.func,
        tab: PropTypes.object,
        windowId: PropTypes.string,
        windowType: PropTypes.string
    }

    static defaultProps = {
        feature: {},
        tab: {},
        windowId: ''
    }

    constructor(props) {
        super(props);
        this.container = React.createRef();
        this.state = {
            data: {},
            isLoading: true
        };
    }

    componentDidMount() {
        const url = FeatureUtils.prepareUrl(this.props.feature, this.props.tab.url);

        const components = new OBC.Components();
        this.components = components;
        this.unmounted = false;
        const worlds = components.get(OBC.Worlds);

        const world = worlds.create();

        world.scene = new OBC.SimpleScene(components);
        world.renderer = new OBC.SimpleRenderer(components, this.container.current);
        world.camera = new OBC.SimpleCamera(components);

        components.init();

        world.scene.setup();

        const loadIfc = async () => {
            const fragmentIfcLoader = components.get(OBC.IfcLoader);
            await fragmentIfcLoader.setup();

            fragmentIfcLoader.settings.excludedCategories.add(WEBIFC.IFCSPACE);

            fragmentIfcLoader.settings.webIfc.COORDINATE_TO_ORIGIN = true;

            const file = await fetch(url);
            if (!file.ok) {
                // e.g. 404, do not hand an error page over to the ifc parser
                // eslint-disable-next-line no-console
                // (without the query, it may contain an access token)
                console.log("IFC model not available (" + file.status + "): " + url.split("?")[0]);
                return;
            }
            const data = await file.arrayBuffer();
            if (this.unmounted) {
                return;
            }
            const buffer = new Uint8Array(data);
            const model = await fragmentIfcLoader.load(buffer);
            model.name = "example";
            world.scene.three.add(model);
        };

        loadIfc().catch(error => {
            // eslint-disable-next-line no-console
            console.log("IFC model could not be loaded: " + (error?.message ?? error));
        });
    }

    componentWillUnmount() {
        this.unmounted = true;
        try {
            this.components?.dispose();
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log("IFC viewer could not be disposed: " + (error?.message ?? error));
        }
        this.components = null;
    }

    render() {
        return (
            <div ref={this.container} style={{width: '100%', height: '100%'}}/>
        );
    }
}

const selector = () => ({});

export default connect(selector, {
    setDetailWindow: setDetailWindow,
    addDetailWindow: addDetailWindow,
})(IfcTab);
